const abilityField = 'open_end_show';
const abilityNField = 'open_end_selected_max_display';
const imageViewVerticalField = 'open_end_image_view_vertical';
const showStimuliField = 'show_stimuli';

export { abilityField, abilityNField, imageViewVerticalField, showStimuliField };
